import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_DATA_DISABLE_PETSVC_SALESFORCE_WORKER = createFcmDetails(
	'data_disable_petsvc_salesforce_worker',
	{
		owner: 'Site Platform',
		context: 'Petition Service',
		import: false,
		description: `Disables the worker that writes data to Salesforce.

			This will allow us to transition the writes to the new AWS Glue ETL process.`,
	},
);
